// @flow
import client from '../../client'

// Constants
export const GET_GBT_PAYLOADS_ENDPOINT = '/corporate/gbt/payloads/'

/**
 * Get GBT payloads
 * @return {Promise|Error} A resolved Promise with the server response or Rejected with an Error
 */
export const getGBTPayloads = () => client.get(GET_GBT_PAYLOADS_ENDPOINT)

export default getGBTPayloads
